<div [innerHTML]="safeHtml">
    <!-- Dynamic HTML content will be rendered here -->
</div>